import React from 'react';


export default function Error404View() {
  return (
    <h1>Page Not Found!</h1>
  )
}
